import {
  // -- GET (list)
  LIST_SCENARIO_SUCCESS,
  LIST_SCENARIO_FAILURE,
  // -- GET (one)
  GET_SCENARIO_SUCCESS,
  GET_SCENARIO_FAILURE,
  // -- UPDATE
  UPDATE_SCENARIO_SUCCESS,
  UPDATE_SCENARIO_FAILURE,
  // -- CREATE
  CREATE_SCENARIO_SUCCESS,
  CREATE_SCENARIO_FAILURE,
  // -- DELETE
  DELETE_SCENARIO_SUCCESS,
  DELETE_SCENARIO_FAILURE,
  // -- SEARCH
  SEARCH_SCENARIOS
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

let cacheItems = null

export const scenarios = (state = {}, action) => {
  switch (action.type) {
    // -- SEARCH SCENARIOS
    case SEARCH_SCENARIOS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }
      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      // Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarios.SEARCH_SCENARIOS()', { state, cacheItems, txt: action.data, searchItems })
      return {
        ...state,
        items: searchItems
      }
    }

    // -- GET SCENARIOS (list)
    case LIST_SCENARIO_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarios.LIST_SCENARIO_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case LIST_SCENARIO_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarios.LIST_SCENARIO_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- GET SCENARIO (one)
    case GET_SCENARIO_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarios.GET_SCENARIO_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_SCENARIO_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarios.GET_SCENARIO_SUCCESS()', { state, action })
      return {
        ...state,
        currentScenario: action.data
      }
    }

    // -- CREATE SCENARIO
    case CREATE_SCENARIO_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarios.CREATE_SCENARIO_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_SCENARIO_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarios.CREATE_SCENARIO_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE SCENARIO
    case UPDATE_SCENARIO_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarios.UPDATE_SCENARIO_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_SCENARIO_SUCCESS: {
      const newItems = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarios.UPDATE_SCENARIO_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- DELETE SCENARIO
    case DELETE_SCENARIO_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarios.DELETE_SCENARIO_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_SCENARIO_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data.id)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarios.DELETE_SCENARIO_SUCCESS()', { state, action, items })

      return {
        ...state,
        items
      }
    }

    default:
      return state
  }
}
